/// <reference path="../../polaris-web-components.d.ts" />
import React from 'react';

/**
 * Banner components for trial notifications, charge alerts, and scope updates
 */

export const TrialBanner = ({ trialDays, chargeBtnLoad, onActivate, onDismiss }) => {
  if (trialDays <= 0 || trialDays > 7) return null;

  return (
    <s-page>
      <s-box paddingBlockEnd="small">
        <s-banner
          heading={`Only ${trialDays} day(s) left in your trial`}
          tone="info"
          dismissible
          onDismiss={onDismiss}
        >
          <s-text>Please activate your subscription soon to avoid disruption.</s-text>
          <s-button slot="secondary-actions" loading={chargeBtnLoad} onClick={onActivate}>
            Activate
          </s-button>
        </s-banner>
      </s-box>
    </s-page>
  );
};

export const ChargeBanner = ({ chargeBtnLoad, onActivate }) => (
  <s-page>
    <s-box paddingBlockEnd="small">
      <s-banner
        heading="Activate charge"
        tone="info"
      >
        <s-text>Your store has reached the products limit of 100. Please select and activate a plan to continue using the app.</s-text>
        <s-button slot="secondary-actions" loading={chargeBtnLoad} onClick={onActivate}>
          View Plans
        </s-button>
      </s-banner>
    </s-box>
  </s-page>
);

export const ChargeDowngradeBanner = ({ btnLoad, onChangeplan }) => (
  <s-page>
    <s-box paddingBlockEnd="small">
      <s-banner
      heading="Plan downgrade"
      tone="info"
      >
        <s-text>We noticed that you have accepted a recurring charge but currently have fewer than 100 products. Would you like to switch to our free plan?</s-text>
        <s-button slot="secondary-actions" loading={btnLoad} onClick={onChangeplan}>
          Change plan
        </s-button>
      </s-banner>
    </s-box>
  </s-page>
);

export const UpdateScopeBanner = ({ pathname, onAllow }) => {
  const scopeMessages = {
    '/customers': 'This app needs permission to read and update customers, please click allow below.',
    '/collections': 'This app needs permission to read and update collections, please click allow below.',
    '/metaobjects': 'This app needs permission to read and update metaobjects, please click allow below.',
    '/definitions': 'This app needs permission to read and update definitions, please click allow below.',
    '/translations': 'This app needs permission to read and update translations, please click allow below.',
    '/orders': 'This app needs permission to read and update orders, please click allow below.',
    '/menu': 'This app needs permission to read and update menu items, please click allow below.',
    'default': 'This app needs permission to read and update pages, please click allow below.'
  };

  const message = scopeMessages[pathname] || scopeMessages['default'];

  return (
    <s-banner
      heading="Permissions required"
      tone="warning"
    >
      <s-text>{message}</s-text>
      <s-button slot="secondary-actions" onClick={onAllow}>
        Allow
      </s-button>
    </s-banner>
  );
};
